import * as React from 'react';
import { Box, Card, CardActions, Button, Typography, CircularProgress } from '@mui/material';
import {
    Form, TextInput, PasswordInput,
    useAuthProvider, useNotify, useRedirect,
    email as reactAdminEmailValidator
} from 'react-admin';
import { useState } from 'react'
import SignupIcon from '@mui/icons-material/JoinInner';
import LoginIcon from '@mui/icons-material/Login';
import { validateForm } from './utils';

const SimpleLogin = ({ initialMode }) => {
    const [loading, setLoading] = useState(false);
    const [mode, setMode] = useState(initialMode ?? 'signin');

    const notify = useNotify();
    const authProvider = useAuthProvider();
    const redirect = useRedirect();

    const handleError = (error) => {
        setLoading(false);
        const text = mode == 'signin' ? 'Sign in failed' : 'Create account failed';
        notify(
            typeof error === 'string'
                ? error
                : typeof error === 'undefined' || !error.message
                    ? text
                    : error.message,
            {
                type: 'warning',
                messageArgs: {
                    _:
                        typeof error === 'string'
                            ? error
                            : error && error.message
                                ? error.message
                                : undefined,
                },
            }
        );
    }

    const handleSubmit = (auth) => {
        // console.log(auth)
        setLoading(true);
        if (mode == 'signin') {
            authProvider
                .login({ username: auth.email, password: auth.password })
                .then(({ redirectTo }) => redirect(redirectTo ?? '/'))
                .catch(handleError)
        }
        if (mode == 'signup') {
            authProvider
                .signup({ email: auth.email, password: auth.password, name: auth.name })
                .then(({ redirectTo }) => redirect(redirectTo ?? '/'))
                .catch(handleError)
        }
    }

    const handleEmailBlur = (e) => {
        const email = e.target.value;
        if (email && !reactAdminEmailValidator()(email)) {
            authProvider
                .isEmailTaken(email)
                .then((isTaken) => {
                    if (!isTaken) {
                        setMode('signup')
                    } else {
                        setMode('signin')
                    }
                })
                .catch(handleError)
        }
    }

    return (
        <Form onSubmit={handleSubmit} validate={validateForm(mode)}>
            <Card
                sx={{
                    padding: '20px',
                    // marginTop: 2,
                    // marginBottom: '1em',
                }}
            >
                <Typography variant="h5" gutterBottom>
                    Sign in or Create account
                </Typography>

                <Box maxWidth="80em">
                    <Typography variant="body1" component="p" gutterBottom>
                        Experience online cloud computing services.
                    </Typography>
                </Box>

                <Box maxWidth={500}>

                    <Box display={{ xs: 'block', sm: 'flex', width: '100%' }}>
                        <Box flex={1} mr={{ xs: 0, sm: '0.5em' }}>
                            <TextInput source="email" fullWidth disabled={loading} required onBlur={handleEmailBlur} />
                        </Box>
                        <Box flex={1} ml={{ xs: 0, sm: '0.5em' }}>
                            <PasswordInput source="password" fullWidth disabled={loading} required />
                        </Box>
                    </Box>

                    {mode == 'signup' &&
                        <Box display={{ xs: 'block', sm: 'flex', width: '100%' }}>
                            <Box flex={1} mr={{ xs: 0, sm: '0.5em' }}>
                                <TextInput source="name" fullWidth disabled={loading} required />
                            </Box>
                            <Box flex={1} ml={{ xs: 0, sm: '0.5em' }}>
                                <PasswordInput source="confirm_password" fullWidth disabled={loading} required />
                            </Box>
                        </Box>
                    }

                </Box>

                <CardActions
                    sx={{
                        padding: { xs: 0, xl: null },
                        flexWrap: { xs: 'wrap', xl: null },
                        '& a': {
                            marginTop: { xs: '1em', xl: null },
                            marginLeft: { xs: '0!important', xl: null },
                            marginRight: { xs: '1em', xl: null },
                        },
                    }}
                >
                    {mode == 'signin' &&
                        <Button variant="contained" type="submit" color="primary" disabled={loading} startIcon={<LoginIcon />}>
                            Sign in
                        </Button>
                    }
                    {mode == 'signup' &&
                        <Button variant="contained" type="submit" color="primary" disabled={loading} startIcon={<SignupIcon />}>
                            Sign up
                        </Button>
                    }
                    {loading && (
                        <Box paddingLeft={'1em'}>
                            <CircularProgress size={16} thickness={6} />
                        </Box>
                    )}
                </CardActions>
            </Card >
        </Form >
    );
};

export default SimpleLogin;
